import { locationsManagementApi } from '@/api';

const locationsManagementFilters = [
  {
    name: 'name',
    label: 'name',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'description',
    label: 'description',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'code',
    label: 'code',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'enabled',
    label: 'activeInactive',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'filters.active', value: 1 },
      { label: 'filters.inactive', value: 0 },
    ],
  },
];

export default locationsManagementFilters;
